<template>
  <div class="week-fast-news-list">
    <div class="week-fast-news-list-header">
      <img src="../../assets/img/lightning.svg" class="lightning-img" alt="">
      <span>7*24小时新闻快讯</span>
      <div v-if="showUnread" @click="onShowNewMessage" class="row unread-message">
        <img src="../../assets/img/arrow-up.svg" class="icon" alt="">
        <div class="unread-count">{{latestNewsData.length}}条新快讯</div>
      </div>
    </div>
    <div v-loading="isLoading" class="week-fast-news-list-detail">
      <div v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10">
        <day-fast-news-list v-for="(item, index) in newsFlashList" :latestNewsData="latestNewsData" :key="index" :date="item.date" :list="item.list" :data="item"></day-fast-news-list>
      </div>
    </div>
  </div>
</template>

<script>
import QuestionQuery from '@/rest/questionQuery';
import DayFastNewsList from '@/components/recommend/DayFastNewsList';

export default {
  name: 'week-fast-news-list',
  data() {
    return {
      isLoading: false,
      pageNum: 1,
      pageSize: 20,
      list: [],
      showUnread: false,
      busy: false,
      timer: null,
      timer1: null,
      timer2: null,
      firstDay: '',
      firstMonth: '',
      earliestNewsId: -1,
      latestNewsId: -1,
      doc: null,
      earliestDate: '',
      newsFlashList: [],
      latestNewsData: []
    };
  },
  components: {
    DayFastNewsList
  },
  methods: {
    getNewsFlashNew() {
      QuestionQuery.getNewsFlashNew(this.latestNewsId).then(
        res => {
          if (res.length) {
            this.latestNewsId = res[0].list[0].newsId;
            if (this.doc.scrollTop >= 0 && this.doc.scrollTop <= 300) {
              this.showUnread = false;
              this.doc.scrollTop = 0;
              res.forEach(item => {
                if (item.date === this.newsFlashList[0].date) {
                  this.newsFlashList = this.newsFlashList.map((i, idx) => {
                    if (!idx) {
                      i.list.unshift(...item.list);
                    }
                    return {
                      date: i.date,
                      list: i.list
                    };
                  });
                }
              });
            } else if (this.doc.scrollTop > 300) {
              this.showUnread = true;
              res.forEach(item => {
                this.latestNewsData = this.latestNewsData.concat(item.list);
                if (item.date === this.newsFlashList[0].date) {
                  this.newsFlashList = this.newsFlashList.map((i, idx) => {
                    if (!idx) {
                      i.list.unshift(...item.list);
                    }
                    return {
                      date: i.date,
                      list: i.list
                    };
                  });
                }
              });
            }
          }
        },
        () => {
          this.getNewsFlashNewSetInterval(false);
        }
      );
    },
    onShowNewMessage() {
      this.showUnread = false;
      if (this.latestNewsData.length > 50) {
        this.latestNewsData = [];
        this.doc.scrollTop = 0;
      } else {
        this.latestNewsData = [];
        this.timer2 = setInterval(() => {
          if (this.doc.scrollTop) {
            this.doc.scrollTop = this.doc.scrollTop - 200;
          } else if (!this.doc.scrollTop || this.doc.scrollTop < 0) {
            clearInterval(this.timer2);
          }
        }, 50);
      }
    },
    getNewsFlashOld() {
      this.isLoading = true;
      QuestionQuery.getNewsFlashOld(this.pageNum, this.pageSize, this.earliestNewsId).then(res => {
        this.isLoading = false;
        if (res.length) {
          const lastList = res[res.length - 1].list;
          this.earliestNewsId = lastList[lastList.length - 1].newsId;
          if (this.newsFlashList[this.newsFlashList.length - 1].date === res[0].date) {
            this.newsFlashList[this.newsFlashList.length - 1].list = this.newsFlashList[this.newsFlashList.length - 1].list.concat(res.shift().list);
            this.newsFlashList = this.newsFlashList.concat(res);
          } else {
            this.newsFlashList = this.newsFlashList.concat(res);
          }
          this.busy = false;
        } else {
          this.busy = true;
        }
      });
    },
    getFirstNewsFlashOld() {
      this.isLoading = true;
      QuestionQuery.getNewsFlashOld(this.pageNum, this.pageSize, this.earliestNewsId).then(res => {
        this.isLoading = false;
        this.latestNewsId = res[0].list[0].newsId;
        if (res.length) {
          const lastList = res[res.length - 1].list;
          this.earliestNewsId = lastList[lastList.length - 1].newsId;
          this.newsFlashList = this.newsFlashList.concat(res);
          this.busy = false;
        }
        this.getNewsFlashNewSetInterval(true);
      });
    },
    getNewsFlashNewSetInterval(start) {
      if (this.timer1) {
        clearTimeout(this.timer1);
      }
      if (start) {
        this.timer1 = setTimeout(() => {
          this.getNewsFlashNew();
          this.getNewsFlashNewSetInterval(start);
        }, 1000 * 10);
      }
    },
    loadMore() {
      this.busy = true;
      if (this.timer) {
        clearTimeout(this.timer);
      }
      if (this.newsFlashList.length) {
        this.timer = setTimeout(() => {
          this.pageNum++;
          this.getNewsFlashOld();
        }, 500);
      }
    }
  },
  mounted() {
    this.doc = document.querySelector('.week-fast-news-list-detail');
    this.getFirstNewsFlashOld();
  },
  beforeDestroy() {
    this.getNewsFlashNewSetInterval(false);
    if (this.timer2) {
      clearInterval(this.timer2);
    }
  }
};
</script>

<style lang="scss" scoped>
.icon {
  width: 16px;
}
.week-fast-news-list {
  .week-fast-news-list-header {
    position: relative;
    padding: 12px 16px;
    color: #171f46;
    font-size: 14px;
    box-shadow: inset 0px -1px 0px 0px#f7f7fa;
    .lightning-img {
      width: 14px;
      margin-right: 4px;
      margin-bottom: -1px;
    }
    .unread-message {
      position: absolute;
      top: 52px;
      left: 50%;
      transform: translateX(-50%);
      padding: 0 12px;
      height: 17px;
      background-color: #636772;
      border-radius: 2px;
      z-index: 1;
      cursor: pointer;
      .unread-count {
        margin-right: 4px;
        color: #ffffff;
        font-size: 12px;
        cursor: pointer;
      }
    }
  }
  .week-fast-news-list-detail {
    padding: 0 16px 0 29px;
    height: calc(100vh - 124px);
    overflow: auto;
    .week-fast-news-list-detail-date {
      position: relative;
      width: 100%;
      height: 25px;
      border-left: solid 2px #f7f7fa;
      .date-content {
        position: absolute;
        top: 8px;
        left: -16px;
        height: 17px;
        line-height: 17px;
        width: 64px;
        border: 1px solid #45a8cc;
        border-radius: 2px;
        font-size: 12px;
        .date-content-month {
          width: 36px;
          text-align: center;
          color: #464d6c;
          background-color: #ffffff;
        }
        .date-content-day {
          width: 29px;
          text-align: center;
          color: #ffffff;
          background-color: #45a8cc;
        }
      }
    }
  }
}
</style>
